export default __webpack_public_path__ + "static/media/button__send-message.ce135218.svg";